import { NewsroomBlockTemplate } from "./newsroom-block.template";

export default {
    title: "Website/Page Templates/Homepage/Homepage Blocks/Newsroom Block",
    render: NewsroomBlockTemplate.bind({}),
    parameters: {
        layout: "fullscreen",
        inline: false,
        height: "700px",
    },
    args: {
        withInfoTeaser: true,
    },
    argTypes: {
        withInfoTeaser: {
            control: "boolean",
        },
    },
};

export const Default = {};
